import { req } from "./axiosFun";

// 获取订单列表
export const orderList = params => {
  return req("get", "/api/Drugs/orderList", params);
};
// 获取分类列表
export const categoryList = params => {
  return req("get", "/api/Drugs/categoryList", params);
};
// 药品分类添加
export const categoryAdd = params => {
  return req("post", "/api/Drugs/categoryAdd", params);
};
// 药品分类删除
export const categoryDel = params => {
  return req("post", "/api/Drugs/categoryDel", params);
};
// 药品分类编辑
export const categoryEdit = params => {
  return req("post", "/api/Drugs/categoryEdit", params);
};
// 药品分类药品列表
export const drugsList = params => {
  return req("post", "/api/Drugs/drugsList", params);
};
// 药品分类药品添加
export const drugListAdd = params => {
  return req("post", "/api/Drugs/drugListAdd", params);
};
// 药品分类药品添加列表
export const Drugslist = params => {
  return req("post", "/api/Drugs/list", params);
};
// 药品分类药品删除
export const drugListDel = params => {
  return req("post", "/api/Drugs/drugListDel", params);
};
// 药品分类药品修改
export const drugListEdit = params => {
  return req("post", "/api/Drugs/drugListEdit", params);
};
// 药品分类药品修改
export const Upload = params => {
  return req("post", "/api/Upload/up", params);
};


// WEBPACK FOOTER //
// ./src/api/ypgl.js